import React, { useEffect } from 'react';
import './Toast.scss';

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XCircleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const ICONS = { success: CheckIcon, error: XCircleIcon, info: InfoIcon };

// Track visible toasts for stacking
let toastCounter = 0;
const activeToasts = new Set();

export default function Toast({ show, type = 'info', message, onClose, duration = 4000 }) {
  const [slotIndex, setSlotIndex] = React.useState(0);
  const idRef = React.useRef(null);

  React.useEffect(() => {
    if (show) {
      if (!idRef.current) {
        idRef.current = ++toastCounter;
        activeToasts.add(idRef.current);
      }
      // Calculate position based on currently active toasts below this one
      let idx = 0;
      for (const id of activeToasts) {
        if (id === idRef.current) break;
        idx++;
      }
      setSlotIndex(idx);
    } else {
      if (idRef.current) {
        activeToasts.delete(idRef.current);
        idRef.current = null;
      }
    }
  }, [show]);

  useEffect(() => {
    if (!show || !duration) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [show, duration, onClose]);

  if (!show) return null;

  const Icon = ICONS[type] || ICONS.info;
  const topOffset = 16 + slotIndex * 64;

  return (
    <div className={`toast toast--${type}`} style={{ top: `${topOffset}px` }} onClick={onClose}>
      <div className="toast__icon"><Icon /></div>
      <div className="toast__message">{message}</div>
      <button className="toast__close" onClick={(e) => { e.stopPropagation(); onClose(); }}>
        <CloseIcon />
      </button>
    </div>
  );
}
